var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-table",
    { staticClass: "model-virtual-list", attrs: { selectable: "" } },
    [
      _c(
        "sui-table-header",
        [
          _c(
            "sui-table-row",
            [
              _c("sui-table-header-cell"),
              _vm._l(_vm.columns, function (column, index) {
                return _c("sui-table-header-cell", { key: index }, [
                  _vm._v(" " + _vm._s(column) + " "),
                ])
              }),
              _c("sui-table-header-cell"),
            ],
            2
          ),
        ],
        1
      ),
      _vm.models
        ? _c(
            "sui-table-body",
            _vm._l(_vm.models, function (model, index) {
              return _c(
                "sui-table-row",
                { key: model.id },
                [
                  _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                    _vm._v(_vm._s(index + 1)),
                  ]),
                  _c("sui-table-cell", [_vm._v(_vm._s(model.name))]),
                  _c("sui-table-cell", [
                    _vm._v(_vm._s(_vm.toDatetime(model.created_date))),
                  ]),
                  _c("sui-table-cell", [
                    _vm._v(_vm._s(_vm.toDatetime(model.last_modified_date))),
                  ]),
                  _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                    _c(
                      "div",
                      { staticClass: "model-menu" },
                      [
                        _c("font-awesome-icon", {
                          staticClass: "model-menu-icon eye",
                          attrs: { icon: "eye" },
                          on: {
                            click: function ($event) {
                              return _vm.viewModel(model.id)
                            },
                          },
                        }),
                        _c("font-awesome-icon", {
                          staticClass: "model-menu-icon pencil-alt",
                          attrs: { icon: "pencil-alt" },
                          on: {
                            click: function ($event) {
                              return _vm.editModel(model.id)
                            },
                          },
                        }),
                        _c("font-awesome-icon", {
                          staticClass: "model-menu-icon trash",
                          attrs: { icon: "trash-alt" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteModel(model)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            }),
            1
          )
        : _c("div", [_c("p", [_vm._v("Not models found.")])]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }